export class SetSupplierRevolutBalance {
    public supplierID: string;
    public accountID: string;
    public newBalance: number;
}
